import { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement>;

export const Icon = {
  Search: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <circle cx="7" cy="7" r="4.5" stroke="currentColor" strokeWidth="1.4" />
      <path d="M10.5 10.5 L 14 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
  Home: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M2 8 L 8 3 L 14 8 V 13 H 2 Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  ),
  Scan: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...p}>
      <path
        d="M3 5 V 3 H 5 M 11 3 H 13 V 5 M 13 11 V 13 H 11 M 5 13 H 3 V 11"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path d="M3 8 H 13" stroke="currentColor" strokeWidth="1.4" strokeDasharray="2 2" />
    </svg>
  ),
  Compare: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...p}>
      <rect x="2.5" y="3.5" width="5" height="9" stroke="currentColor" strokeWidth="1.4" />
      <rect x="8.5" y="3.5" width="5" height="9" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  ),
  Leaderboard: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...p}>
      <path
        d="M3 13 V 8 H 6 V 13 M 6 13 V 5 H 10 V 13 M 10 13 V 9 H 13 V 13"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  ),
  About: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...p}>
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4" />
      <path d="M8 7 V 11 M 8 5 V 5.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
  Play: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M4 3 L 13 8 L 4 13 Z" />
    </svg>
  ),
  Pause: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <rect x="4" y="3" width="3" height="10" />
      <rect x="9" y="3" width="3" height="10" />
    </svg>
  ),
  Copy: (p: P) => (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" {...p}>
      <rect x="3" y="3" width="8" height="8" stroke="currentColor" strokeWidth="1.4" />
      <path d="M5 5 H 13 V 13 H 5" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  ),
  Plus: (p: P) => (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M8 3 V 13 M 3 8 H 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  X: (p: P) => (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M4 4 L 12 12 M 12 4 L 4 12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
  Chevron: (p: P) => (
    <svg width="10" height="10" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M5 4 L 11 8 L 5 12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Caret: (p: P) => (
    <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M3 6 L 8 11 L 13 6 Z" />
    </svg>
  ),
  Upload: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M8 11 V 3 M 5 6 L 8 3 L 11 6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 11 V 13 H 14 V 11" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  ),
  Link: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <path
        d="M7 9 L 9 7 M 5 11 a 2 2 0 0 1 0 -3 L 7 6 M 11 5 L 9 7 M 13 5 a 2 2 0 0 0 -3 0 L 9 6"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  Settings: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.3" />
      <path
        d="M8 1 V 3 M 8 13 V 15 M 1 8 H 3 M 13 8 H 15 M 3 3 L 4.5 4.5 M 11.5 11.5 L 13 13 M 3 13 L 4.5 11.5 M 11.5 4.5 L 13 3"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  ),
  ArrowDown: (p: P) => (
    <svg width="10" height="10" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M8 3 V 13 M 4 9 L 8 13 L 12 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ArrowUp: (p: P) => (
    <svg width="10" height="10" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M8 13 V 3 M 4 7 L 8 3 L 12 7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Filter: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M2 4 H 14 L 10 9 V 13 L 6 11 V 9 Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  ),
  Share: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <circle cx="4" cy="8" r="2" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="12" cy="4" r="2" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.4" />
      <path d="M5.5 7 L 10.5 4.5 M 5.5 9 L 10.5 11.5" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  ),
  Check: (p: P) => (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M3 8 L 7 12 L 13 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Warn: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" {...p}>
      <path d="M8 2 L 14 13 H 2 Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M8 7 V 10 M 8 11.5 V 12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
};
